import {
  ApplicationStages,
  ApplicationStatusResponse,
  OutcomeTypes,
  StatusTypes,
} from "../../your-applications.consts";

export const applicationStatusMapV2: Record<string, ApplicationStatusResponse> =
  {
    "application-quote": {
      applicationStage: ApplicationStages.ESTIMATE,
      offerStatus: { status: StatusTypes.ACTION, message: "Select offer" },
      submissionStatus: {
        status: StatusTypes.INACTIVE,
        message: "Application submission",
      },
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: null,
    },

    "application-pre-submission": {
      applicationStage: ApplicationStages.ESTIMATE,
      offerStatus: {
        status: StatusTypes.COMPLETE,
        message: "Rate offer selected",
      },
      submissionStatus: {
        status: StatusTypes.ACTION,
        message: "Complete app form",
      },
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: null,
    },

    "credit-approval-initial-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info to start assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-initial-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info to start assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "credit-approval-awaiting-assessment": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Queued for assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-awaiting-assessment": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Queued for assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "credit-approval-with-assessor": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Picked up by assessor",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-with-assessor": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Picked up by assessor",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "credit-approval-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info to continue assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info to continue assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "credit-approval-in-review": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "In review for Conditional approval",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-in-review": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "In review for Conditional approval",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "formal-approval-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Conditionally approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info for Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "formal-approval-in-review": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Conditionally approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "In review for Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "settlement-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Conditionally approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Formally approved",
      },
      settlementStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info for Settlement",
      },
      archiveStatus: null,
    },

    "settlement-in-review": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Conditionally approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Formally approved",
      },
      settlementStatus: {
        status: StatusTypes.PENDING,
        message: "In review for Settlement",
      },
      archiveStatus: null,
    },

    "settlement-ready-to-settle": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Conditionally approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Formally approved",
      },
      settlementStatus: {
        status: StatusTypes.PENDING,
        message: "Ready for settlement",
      },
      archiveStatus: null,
    },

    settled: {
      applicationStage: ApplicationStages.ARCHIVE,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: { outcome: OutcomeTypes.SETTLED },
    },

    declined: {
      applicationStage: ApplicationStages.ARCHIVE,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: { outcome: OutcomeTypes.DECLINED },
    },

    withdrawn: {
      applicationStage: ApplicationStages.ARCHIVE,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: { outcome: OutcomeTypes.WITHDRAWN },
    },

    expired: {
      applicationStage: ApplicationStages.ARCHIVE,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: { outcome: OutcomeTypes.EXPIRED },
    },

    "queued-credit-assessment": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Queued for credit assessment",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "credit-review": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "In credit review",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "provide-info-credit-assessment": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info for credit assessment",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "queued-verify-declared-info": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Queued to verify declared info",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "verifying-declared-info": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Verifying declared info",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "provide-info-verification": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info for verification",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "provide-info-finalise-contract": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info to finalise contract",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "finalising-approval-and-contract": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Finalising approval and contract",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "provide-info-settlement": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info for settlement",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "final-settlement-checks": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Final settlement checks",
      },
      settlementStatus: null,
      archiveStatus: null,
    },

    "ready-for-settlement": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Ready for Settlement",
      },
      settlementStatus: null,
      archiveStatus: null,
    },
  };

export const applicationStatusMapV1: Record<string, ApplicationStatusResponse> =
  {
    "application-quote": {
      applicationStage: ApplicationStages.ESTIMATE,
      offerStatus: { status: StatusTypes.ACTION, message: "Select offer" },
      submissionStatus: {
        status: StatusTypes.INACTIVE,
        message: "Application submission",
      },
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: null,
    },

    "application-pre-submission": {
      applicationStage: ApplicationStages.ESTIMATE,
      offerStatus: {
        status: StatusTypes.COMPLETE,
        message: "Rate offer selected",
      },
      submissionStatus: {
        status: StatusTypes.ACTION,
        message: "Complete app form",
      },
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: null,
    },

    "credit-approval-initial-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info to start assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-initial-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info to start assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "credit-approval-awaiting-assessment": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Queued for assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-awaiting-assessment": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Queued for assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "credit-approval-with-assessor": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Picked up by assessor",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-with-assessor": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "Picked up by assessor",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "credit-approval-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info to continue assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info to continue assessment",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "credit-approval-in-review": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "In review for Credit approval",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "conditional-approval-in-review": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "In review for Credit approval",
      },
      formalApprovalStatus: {
        status: StatusTypes.INACTIVE,
        message: "Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "formal-approval-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Credit approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info for Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "formal-approval-in-review": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Credit approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.PENDING,
        message: "In review for Formal approval",
      },
      settlementStatus: { status: StatusTypes.INACTIVE, message: "Settlement" },
      archiveStatus: null,
    },

    "settlement-actions-required": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Credit approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Formally approved",
      },
      settlementStatus: {
        status: StatusTypes.ACTION,
        message: "Provide info for Settlement",
      },
      archiveStatus: null,
    },

    "settlement-in-review": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Credit approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Formally approved",
      },
      settlementStatus: {
        status: StatusTypes.PENDING,
        message: "In review for Settlement",
      },
      archiveStatus: null,
    },

    "settlement-ready-to-settle": {
      applicationStage: ApplicationStages.OPEN,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Credit approved",
      },
      formalApprovalStatus: {
        status: StatusTypes.COMPLETE,
        message: "Formally approved",
      },
      settlementStatus: {
        status: StatusTypes.PENDING,
        message: "Ready for settlement",
      },
      archiveStatus: null,
    },

    settled: {
      applicationStage: ApplicationStages.ARCHIVE,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: { outcome: OutcomeTypes.SETTLED },
    },

    declined: {
      applicationStage: ApplicationStages.ARCHIVE,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: { outcome: OutcomeTypes.DECLINED },
    },

    withdrawn: {
      applicationStage: ApplicationStages.ARCHIVE,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: { outcome: OutcomeTypes.WITHDRAWN },
    },

    expired: {
      applicationStage: ApplicationStages.ARCHIVE,
      offerStatus: null,
      submissionStatus: null,
      conditionalApprovalStatus: null,
      formalApprovalStatus: null,
      settlementStatus: null,
      archiveStatus: { outcome: OutcomeTypes.EXPIRED },
    },
  };
